module.exports = __webpack_public_path__ + "img/liruihua.09545aa3.jpg";